let cart = {
    init() {
        if($('main').hasClass('page-cart')){
            $('<div class="col-right"></div>').appendTo('.page-cart form');
            $('<div class="cart-total"></div>').appendTo('.page-cart .col-right');
            $('.recap').appendTo('.cart-total');
            $('div[data-drupal-selector="order-total-summary"]').appendTo('.cart-total');
            $('#edit-actions').appendTo('.cart-total');
            $('.mention').appendTo('.cart-total');
            $('#edit-coupon-redemption').appendTo('.page-cart .col-right');
        }
    }
}

export default cart;
